import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatRadiobutton = createCustomElementWrapper('kat-radiobutton', 'KatRadiobutton', {
    'constraintLabel': 'constraint-label',
    'katAriaLabel': 'kat-aria-label',
    'katAriaLabelledby': 'kat-aria-labelledby',
    'uniqueId': 'unique-id',
}, {
    'onBlur': 'blur',
    'onChange': 'change',
    'onFocus': 'focus',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/radiobutton.js
// module id = 1297
// module chunks = 0